import { useMediaQuery } from "@vueuse/core";

/**
 * The one place the desktop breakpoint lives.
 *
 * `BaseView` gates every navigation column on it, and the two project wizards render their step rail
 * inline when it is false. Those branches have to be exact complements: two sources of truth would mean
 * either two step rails on screen or, as happened before this existed, none at all below 768px.
 */
export const DESKTOP_MEDIA_QUERY = "(min-width: 768px)";

export const useIsDesktop = () => useMediaQuery(DESKTOP_MEDIA_QUERY);
